import styled, { css } from 'styled-components';
import { media, colors } from '@prisjakt/ui-base';
import { ifProp } from 'styled-tools';

const searchHeight = 45;
const searchHeightMobile = 35;

export const SearchInput = styled.div`
  width: 100%;
  border: 1px solid ${colors.lightBlue1};
  border-bottom: ${props =>
    props.hasResults ? 'none' : `1px solid ${colors.lightBlue1}`};
  border-radius: ${props => (props.hasResults ? '5px 5px 0px 0px' : '5px')};
  overflow: hidden;
`;
export const SearchResult = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 0px 0px 5px 5px;
  overflow: hidden;
  text-align: left;
  ${ifProp(
    'floating',
    css`
      position: absolute;
      top: ${searchHeightMobile}px;
      left: 0;
      right: 0;
      border: ${props =>
        props.hasResults ? `1px solid ${colors.lightBlue1}` : 'none'};
      border-top: none;
      z-index: 10;
      box-shadow: 0 7px 10px 0px rgba(0, 0, 0, 0.15);
      ${media.mediumUp`
      top: ${searchHeight}px;
    `}
    `
  )}
  .pj-ui-search--products {
    padding-top: 0;
  }
`;
